import { Text, Tooltip } from "@govlaunch/web";
import React from "react";
import { containsWordLongerThan } from "~/src/components/collection/bundleCard/utils/cardNameUtils";
import { ICardViewMode } from "~/src/components/collection/cardViewMode";

interface ICollectionCardNameProps {
  viewMode?: ICardViewMode;
  name: string;
}

export default function CollectionCardName({ viewMode = ICardViewMode.Singles, name }: ICollectionCardNameProps) {
  if (name.length > 50) {
    return (
      <Tooltip bg="gray.400" label={name} borderRadius={10}>
        <Text
          color="gray.800"
          display="block"
          textAlign="center"
          clamp={3}
          fontSize={["2xl", "xl", "xl", viewMode === ICardViewMode.Singles ? "2xl" : "xl"]}
          fontWeight="bold"
          wordBreak={containsWordLongerThan(name, 17) ? "break-all" : "normal"}
        >
          {name}
        </Text>
      </Tooltip>
    );
  } else {
    return (
      <Text
        color="gray.800"
        display="block"
        textAlign="center"
        clamp={3}
        fontSize={["2xl", "xl", "xl", viewMode === ICardViewMode.Singles ? "2xl" : "xl"]}
        fontWeight="bold"
        wordBreak={containsWordLongerThan(name, 17) ? "break-all" : "normal"}
      >
        {name}
      </Text>
    );
  }
}
